// EXTERNAL DEPENDENCIES
import { useEffect, useRef } from 'react'

// HELPERS
import { trackImpression } from '../utils/fpti'

// TYPES
import { UnformattedFptiOptions } from '../types'

/**
 * Add and remove event listeners to window
 * @param event event to listen for
 * @param handler callback to handle event action
 */
export function useEventListening(event: string, handler: any) {
  useEffect(() => {
    window.addEventListener(event, handler)

    return () => window.removeEventListener(event, handler)
  }, [event, handler])
}

/**
 * Tracks impression upon a change in the providedoptions
 */
export function useImpressionTracking(options = {} as UnformattedFptiOptions) {
  const originalEventName = useRef(null)

  useEffect(() => {
    if (options?.eventName && options.eventName !== originalEventName.current) {
      originalEventName.current = options.eventName

      options.withMetrics = true

      trackImpression(options)
    }
  }, [options, options?.eventName])
}
